import {
	Component,
	Inject,
	Input,
	ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TransunionComponent } from '../../summary/transunion/transunion.component';
import { WorkdriveComponent } from '../../summary/fulfillment/workdrive/workdrive.component';

@Component({
	selector: 'app-shared-loan-meta-modal',
	templateUrl: './shared-loan-meta-modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			.modal-container {
				height: 80vh;
				overflow-y: auto;
			}

			.modal-header {
				position: sticky;
				top: 0; /* Sticks to the top of its scrolling container */
				background: white; /* Add a background to prevent content from showing through */
				z-index: 10;
				display: flex;
				justify-content: space-between;
				width: 100%;
				background-color: #f7f7f7;
				margin-bottom: 1rem;
			}
		`,
	],
	imports: [
		CdkDrag,
		CdkDragHandle,
		NgIf,
		MatIconButton,
		MatDialogClose,
		MatIcon,
		TransunionComponent,
		WorkdriveComponent,
	],
})
export class SharedLoanMetaModalComponent {
	constructor(@Inject(MAT_DIALOG_DATA) public data) {
		console.log(this.data, 'loan meta modal');
	}
}
